<template>
    <div class="question-item">
        <transition name="van-fade">
            <div v-show="(showQuestion && showQuestion.id === question.id) || show" class="question-title">
                <TextTemplate :text="`${question.indexNo}. ${question.content}`" />
                <ImagePreview :picUrl="question.picUrl" />
            </div>
        </transition>
        <div class="list">
            <div class="item" v-for="opt in question.options" :key="opt.id">
                <div
                    class="title"
                    :class="{
                        'success-state': opt.title === successTitle,
                        'error-state': opt.title === errorTitle,
                    }"
                >
                    {{ opt.title }}
                </div>
                <div class="content" v-if="!isUrl(opt.content)">{{ opt.content }}</div>
                <div class="content" v-else>
                    <img :src="opt.content" />
                </div>
            </div>
        </div>
        <Result :question="question" />
    </div>
</template>
<script>
import ImagePreview from '../../ImagePreview.vue'
import TextTemplate from '../../TextTemplate.vue'
import Result from '../Result.vue'

export default {
    components: { TextTemplate, Result, ImagePreview },
    computed: {
        userAnswerMap() {
            return this.$store.state.paperResult.userAnswerMap
        },
        questionAnalysisMap() {
            return this.$store.state.paperResult.questionAnalysisMap
        },
        showQuestion() {
            const state = this.$store.state.paperResult
            if (state.currentSubQuestion) return state.currentSubQuestion
            if (state.currentQuestion) return state.currentQuestion
            return null
        },
    },
    props: ['question', 'show'],
    data() {
        return {
            successTitle: '',
            errorTitle: '',
        }
    },
    created() {
        const { state, answer } = this.userAnswerMap[`q-${this.question.id}`]
        const analysis = this.questionAnalysisMap[`q-${this.question.id}`]
        if (state) {
            this.successTitle = answer
        } else {
            this.errorTitle = answer
            this.successTitle = analysis.answer
        }
    },
    methods: {
        isUrl(text) {
            const urlPattern = /^(https?:\/\/|www\.)/i
            return urlPattern.test(text)
        },
    }
}
</script>
<style lang="scss" scoped>
@import '@/scss/paper.scss';
.list {
    padding-top: 20px;
    .item {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        .title {
            width: 36px;
            height: 36px;
            border-radius: 42px;
            border: 1px solid #eeeeee;
            color: #999;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 16px;
            flex-shrink: 0;
        }
        .success-state {
            color: #ffff;
            background: $success-color;
            border-color: $success-color;
        }
        .error-state {
            color: #ffffff;
            background: $error-color;
            border-color: $error-color;
        }
        .content {
            font-size: 16px;
            line-height: 1.6em;
            img {
                width: 120px;
            }
        }
    }
}
</style>
